import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { setMessage, setMessageStatus } from "./messages";

import AuthService from "../services/jobs.service";


export const createJob = createAsyncThunk(
    "create/job",
    async (inputs, thunkAPI) => {
        try {
            const data = await AuthService.saveJob(inputs);
            return { user: data.data.data };
        } catch (error) {
            const message =
                (error.response &&
                    error.response.data &&
                    error.response.data.message) ||
                error.message ||
                error.toString();
            thunkAPI.dispatch(setMessage(message));
            return thunkAPI.rejectWithValue();
        }
    }
);

export const myJob = createAsyncThunk(
    "get/job",
    async (inputs, thunkAPI) => {
        try {
            const data = await AuthService.jobList(inputs);
            return { user: data.data.data };
        } catch (error) {
            const message =
                (error.response &&
                    error.response.data &&
                    error.response.data.message) ||
                error.message ||
                error.toString();
            thunkAPI.dispatch(setMessage(message));
            return thunkAPI.rejectWithValue();
        }
    }
);

export const singleJob = createAsyncThunk(
    "get/job-details",
    async (id, thunkAPI) => {
        try {
            const data = await AuthService.jobDetails(id);
            return { user: data.data.data };
        } catch (error) {
            const message =
                (error.response &&
                    error.response.data &&
                    error.response.data.message) ||
                error.message ||
                error.toString();
            thunkAPI.dispatch(setMessage(message));
            return thunkAPI.rejectWithValue();
        }
    }
);

export const deleteJob = createAsyncThunk(
    "get/job-delete",
    async (id, thunkAPI) => {
        try {
            const data = await AuthService.jobDelete(id);
            return { user: data.data.data };
        } catch (error) {
            const message =
                (error.response &&
                    error.response.data &&
                    error.response.data.message) ||
                error.message ||
                error.toString();
            thunkAPI.dispatch(setMessage(message));
            return thunkAPI.rejectWithValue();
        }
    }
);

export const allJob = createAsyncThunk(
    "get/job-alljobs",
    async (inputs, thunkAPI) => {
        try {
            const data = await AuthService.allJobs(inputs);
            return { user: data.data.data };
        } catch (error) {
            const message =
                (error.response &&
                    error.response.data &&
                    error.response.data.message) ||
                error.message ||
                error.toString();
            thunkAPI.dispatch(setMessage(message));
            return thunkAPI.rejectWithValue();
        }
    }
);

export const publicJob = createAsyncThunk(
    "get/job-public",
    async (id, thunkAPI) => {
        try {
            const data = await AuthService.jobPublic(id);
            return { user: data.data.data };
        } catch (error) {
            const message =
                (error.response &&
                    error.response.data &&
                    error.response.data.message) ||
                error.message ||
                error.toString();
            thunkAPI.dispatch(setMessage(message));
            return thunkAPI.rejectWithValue();
        }
    }
);
const initialState = { jobs: null, Status: "IDEL", job: null, alljobs: null };

const jobsSlice = createSlice({
    name: "jobs",
    initialState,
    reducers: {
        reset: () => initialState
    },
    extraReducers: {
        [createJob.fulfilled]: (state, action) => {
            state.Status = "Success";
        },
        [createJob.rejected]: (state, action) => {
            state.Status = "Failed";
        },
        [myJob.fulfilled]: (state, action) => {
            state.jobs = action.payload.user;
        },
        [myJob.rejected]: (state, action) => {
            state.Status = "Failed";
            state.jobs = null;
        },

        [singleJob.fulfilled]: (state, action) => {
            state.job = action.payload.user;
        },
        [singleJob.rejected]: (state, action) => {
            state.Status = "Failed";
            state.job = null;
        },
        [allJob.fulfilled]: (state, action) => {
            state.alljobs = action.payload.user;
        },
        [allJob.rejected]: (state, action) => {
            state.Status = "Failed";
            state.alljobs = null;
        },
        [publicJob.fulfilled]: (state, action) => {
            state.job = action.payload.user;
        },
        [publicJob.rejected]: (state, action) => {
            state.Status = "Failed";
            state.job = null;
        },

    },
});

const { reducer } = jobsSlice;
export default reducer;
